import React from "react";
import {observer} from "mobx-react";
import Label, {LABEL_VARIANT} from "../../../../../../../../../../components/label/label";
import {ILocationLabelsGroup} from "../../../../../../../../stores/compare-value/location-compare-value-list-stores/location-labels-grouper";
import {ILocationToken} from "../../../../../../../../stores/compare-value/location-compare-value-list-stores/location-selection-types";

interface ILocationLabelsProps {
    labelsGroup: ILocationLabelsGroup;
}

/**
 * Renders a parent location tag with nested member regions, cities, or countries.
 * Tokens contain human-readable names, not codes.
 */
const LocationLabels: React.FC<ILocationLabelsProps> = observer(({ labelsGroup }: ILocationLabelsProps) => {
    return (
        <>

            <Label
                key={`parent-${labelsGroup.parentLabel}`}
                labelText={labelsGroup.parentLabel}
                variant={LABEL_VARIANT.ACCENT}
            />

            {labelsGroup.tokens.map((token: ILocationToken, index: number) => {

                /** Token with country, province, and city */
                if (token.province && token.city) {
                    return (
                        <Label
                            key={`city-${index}`}
                            labelText={token.city}
                            variant={LABEL_VARIANT.GRAY}
                        />
                    );
                }

                /** Token with country and province only */
                if (token.province) {
                    return (
                        <Label
                            key={`province-${index}`}
                            labelText={token.province}
                            variant={LABEL_VARIANT.ACCENT_LIGHT}
                        />
                    );
                }

                /** Token with country and city only (no province) */
                if (token.city) {
                    return (
                        <Label
                            key={`city-${index}`}
                            labelText={token.city}
                            variant={LABEL_VARIANT.GRAY}
                        />
                    );
                }

                /** Token with country only - show nested member chip when it differs from the parent label. Happens with semantic groups (e. g. EU) */
                if (token.country !== labelsGroup.parentLabel) {
                    return (
                        <Label
                            key={`country-${index}`}
                            labelText={token.country!}
                            variant={LABEL_VARIANT.ACCENT_LIGHT}
                        />
                    );
                }

                return null;
            })}
        </>
    );
});

export default LocationLabels;
